$(document).ready(function () {
	const handleVariantShades = () => {
		const $title = $('#product-title');
		const $shadeHandler = $('#current-shade');
		const $shades = $('.related__product');

		$shades.each(function () {
			const $this = $(this);

			$this.on('mouseenter', function () {
				$shadeHandler.text($this.data('shade'))
			})
		})

		$('.related__product-list').on('mouseleave', function () {
			$shadeHandler.text($title.find('span').text())
		})
	}

	handleVariantShades();
})